<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="#fff" d="M0 0h16v16H0z"/><path fill="none" stroke="currentColor" d="M.5.5h15v15H.5z"/><path d="M0 0h16v16H0z" style="fill:none" fill="currentColor"/><path fill="none" stroke="currentColor" d="M4 8h8"/><path fill="none" stroke="currentColor" d="M8 0H0" style="stroke-linecap:round;stroke-width:1.4px" transform="rotate(90 2 6)"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-tree-close',
});
</script>
